import { z } from 'zod';

import {
  createEntityAdapterSchema,
  findDuplicateIds,
  findDuplicateNames,
} from '../../base';
import { SmsTemplateSchema } from './sms.schema';

// SMS collection schema
export const SmsSchema = z
  .object({
    templates: createEntityAdapterSchema(SmsTemplateSchema),
  })
  .superRefine((data, ctx) => {
    const templates = Object.values(data.templates.entities).filter(
      template => template.active,
    );
    const duplicateNames = findDuplicateNames(templates);
    const duplicateIds = findDuplicateIds(templates);
    for (const duplicate of duplicateNames) {
      ctx.addIssue({
        path: ['templates', 'entities', duplicate.id, 'name'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate name',
      });
    }
    for (const duplicate of duplicateIds) {
      ctx.addIssue({
        path: ['templates', 'entities', duplicate.id, 'id'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate ID',
      });
    }
  });

export type Sms = z.infer<typeof SmsSchema>;
